import { provideImgixLoader } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { BASE_PATH, BASE_PATH_V2 } from 'api-client';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { provideEchartsCore } from 'ngx-echarts';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { LOG_CONFIG, LogConfig } from 'shared';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './features/authentication/services/auth.interceptor';
import { turnstileInterceptor } from './features/authentication/services/turnstile.interceptor';
import { apiKeyInterceptor } from './interceptors/api-key.interceptor';
import { impersonationInterceptor } from './interceptors/impersonation.interceptor';

// Register ECharts components (tree-shakeable)
echarts.use([
  PieChart,
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  CanvasRenderer,
]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
        },
      },
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        turnstileInterceptor,
        impersonationInterceptor,
        authInterceptor,
        apiKeyInterceptor,
      ]),
    ),
    provideImgixLoader('https://picsum.photos/'),
    {
      provide: BASE_PATH,
      useValue: environment.API_BASE_PATH,
    },
    {
      provide: BASE_PATH_V2,
      useValue: environment.API_BASE_PATH,
    },
    provideEchartsCore({ echarts }),
    MessageService,
    // Provide V2 logging configuration
    {
      provide: LOG_CONFIG,
      useValue: {
        source: environment.logging?.source || 'link-generator-app',
        enableV2Logging: environment.logging?.enableV2Logging ?? false,
        bufferSize: environment.logging?.bufferSize ?? 25,
        flushIntervalMs: environment.logging?.flushIntervalMs ?? 5000,
      } as LogConfig,
    },
  ],
};
